import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useWatch } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../utils/format';
import type { CarFormGroupData } from '../../../FormData.dk.types';
import { radioOptions } from '../../../config/globals';
import { requiredField, requiredUnregisterField } from '../../shared-config';
import { carTotalCostMonthlyFieldOptions } from './config/carTotalCostMonthly';

export function CarFormGroup() {
  const { t } = useTranslation();

  const hasCars = useWatch({ name: 'LoanApplication/HasCars' }) === 'Yes';
  const hasLease = useWatch({ name: 'Frontend/HasLease' }) === 'Yes';

  return (
    <>
      <RadioFieldUI<CarFormGroupData>
        name="LoanApplication/HasCars"
        label={t('HasCars.label')}
        data-testid="has-cars-radio"
        radioStyle="button"
        options={radioOptions}
        registerOptions={requiredField}
      />

      {hasCars && (
        <RadioFieldUI<CarFormGroupData>
          name="Frontend/HasLease"
          label={t('HasLease.label')}
          data-testid="car-lease-input-radio"
          radioStyle="button"
          options={radioOptions}
          registerOptions={requiredUnregisterField}
          shouldTouch
        />
      )}

      {hasLease && (
        <NumberFieldUI<CarFormGroupData>
          name="Car/0/TotalCostMonthly"
          label={t('Car.TotalCostMonthly.label')}
          data-testid="car-lease-amount-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          shouldTouch
          {...carTotalCostMonthlyFieldOptions}
        />
      )}
    </>
  );
}
